import * as React from 'react';
import Slot from './Slot';
import {HIDE_FROM_SCREENSHOT_CLASS} from '../../../configs/vars';

const ScreenshotInvisible = ({children}: React.PropsWithChildren) => (<Slot className={HIDE_FROM_SCREENSHOT_CLASS}>{children}</Slot>);

export default ScreenshotInvisible;
